import { useQuery } from '@apollo/client';
import { getVisitorWatchlist } from 'graphql-queries';
import { convertToUUID } from 'uuid-encoding';

export const useVisitorWatchlist = (
  visitorWatchlistId: string,
  organizationId: string
) => {
  const { data, loading, error, refetch } = useQuery(getVisitorWatchlist, {
    variables: {
      visitorWatchlistId: convertToUUID(visitorWatchlistId),
      organizationId,
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !visitorWatchlistId || !organizationId,
  });

  return {
    data: data?.visitorWatchlist,
    loading,
    error,
    refetch,
  };
};
